import { useTheme } from "@mui/material/styles";

import { useMediaQuery } from "@mui/material";
import Desktop from "./Desktop";
import Mobile from "./Mobile";

const Layout = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      {isMobile && <Mobile {...props} />}
      {!isMobile && <Desktop {...props} />}
    </>
  );
};

export default Layout;
